import request from '@/plugins/axios'

export function getProductCategory() {
  return request({
    url: '/pmenu/category',
    method: 'post'
  })
}